import { HOST } from "../constants/HostConstants";
import { fetchWithRetry } from "../utils/apiRetry";
import { clearCache } from "../services/apiService";

export const propertyCreate = async (
  propertyData,
  setPropertyData,
  setUser,
  features,
  user_id,
  uploadedItems,
  { setWaitingMessage = null } = {}
) => {
  // Validate user_id before sending
  if (!user_id || isNaN(Number(user_id))) {
setPropertyData({
      __error: "Session expired. Please log in again and try again.",
    });
    return;
  }

  const date = new Date();

  const currentDay = String(date.getDate()).padStart(2, "0");
  const currentMonth = String(date.getMonth() + 1).padStart(2, "0");
  const currentYear = date.getFullYear();

  // we will display the date as YYYY-MM-DD
  const currentDate = `${currentYear}-${currentMonth}-${currentDay}`;

  // Validate propertyData is a non-empty object
  if (
    !propertyData ||
    typeof propertyData !== "object" ||
    Object.keys(propertyData).length === 0
  ) {
setPropertyData({
      __error:
        "Property data is missing. Please fill in the property details and try again.",
    });
    return;
  }

  // Log key fields for debugging
// ensure property_status defaults to Active so it shows in Active listings
  const payloadPropertyData = {
    ...propertyData,
    property_status: propertyData?.property_status || "Active",
  };

  try {
    const res = await fetchWithRetry(
      `${HOST}/api/property/propertyCreate`,
      {
        method: "POST",
        body: JSON.stringify({
          propertyData: payloadPropertyData,
          features,
          user_id: Number(user_id),
          uploadedItems,
          currentDate,
        }),
        credentials: "include",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      },
      {
        maxRetries: 3,
        initialDelay: 3000,
        onWaiting: (isWaiting, message) => {
          if (setWaitingMessage) {
            setWaitingMessage(isWaiting ? message : null);
          }
        },
      }
    );

    const contentType = res.headers.get("content-type") || "";
    const bodyText = await res.text();

    if (!res.ok) {
throw new Error(`Server error ${res.status}: ${bodyText}`);
    }

    let data;
    try {
      data = contentType.includes("application/json")
        ? JSON.parse(bodyText)
        : { success: true };
    } catch (e) {
data = { success: true };
    }

    if (process.env.NODE_ENV !== "production") {
}

    // Clear cached property data so My Properties shows fresh data
    clearCache("/api/property/propertyByUser", { user_id: Number(user_id) });
    clearCache("/api/property/allProperties");
    clearCache("/api/property/propertyActive");

    // Signal success with propertyId if available
    setPropertyData(false);
  } catch (error) {
    if (process.env.NODE_ENV !== "production") {
}
    // Signal failure back to UI without triggering success flow
    setPropertyData({
      __error: error?.message || "Property creation failed. Please try again.",
    });
  }
};
